import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);
const KEY = "melic_cart_v1";
export const FREE_SHIPPING_MIN = 150;

function load() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => {
    setItems((cur) => {
      const ex = cur.find((i) => i.product_id === p.id);
      if (ex) return cur.map((i) => (i.product_id === p.id ? { ...i, quantity: Math.min(20, i.quantity + qty) } : i));
      return [...cur, { product_id: p.id, slug: p.slug, name: p.name, price: p.price, image: p.image, quantity: qty }];
    });
    toast(`${p.name} added to bag`);
    setOpen(true);
  };
  const setQty = (id, q) =>
    setItems((cur) => (q <= 0 ? cur.filter((i) => i.product_id !== id) : cur.map((i) => (i.product_id === id ? { ...i, quantity: Math.min(20, q) } : i))));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const shipping = subtotal === 0 || subtotal >= FREE_SHIPPING_MIN ? 0 : 9;
    return { items, count, subtotal, shipping, total: subtotal + shipping, open, setOpen, add, setQty, clear };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
